export default __webpack_public_path__ + "static/media/use_action_back_zc.4d7f59d2.png";